import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./5C7J4IAS.js";
import {
  createStoreContext
} from "./CFEUKV6C.js";

// src/tab/tab-context.tsx
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useTabContext = ctx.useContext;
var useTabScopedContext = ctx.useScopedContext;
var useTabProviderContext = ctx.useProviderContext;
var TabContextProvider = ctx.ContextProvider;
var TabScopedContextProvider = ctx.ScopedContextProvider;

export {
  useTabContext,
  useTabScopedContext,
  useTabProviderContext,
  TabContextProvider,
  TabScopedContextProvider
};
